export default "__VITE_ASSET__B422aEpR__"